import React from 'react';

const OrderDetailsAddress = ({data}) => {
  const typeHexColorMap = {
    "Home": "#ef427c",
    "Office": "#06D6A0",
    "Relatives": "#fb923c",
    "Others": "#4f46e5",
  };

  // const addressdata = {
  //   name: "Michael Thomas",
  //   address1: "1259 Greenfield Drive, Apt 304, San Mateo",
  //   address2: "CA 94403, United States",
  //   phone: "1800 130 5577",
  //   email: "michael.t@memorydoodle.com",
  //   addressType: "Home",
  // };

  return (
    <>
      <div className="relative z-10 flex items-start gap-4 3xl:gap-6" style={{ "--typeColor": typeHexColorMap[data?.billingAddress?.label], }}>
        <div className="relative z-0 flex-shrink-0 w-12 2xl:w-16 text-2xl 2xl:text-3xl aspect-square flex items-center justify-center rounded-lg" style={{ boxShadow: "0 4px 10px -6px var(--typeColor)", color: "var(--typeColor)" }}>
          <div className="absolute inset-0 rounded-lg opacity-10 -z-[2]" style={{ backgroundColor: "var(--typeColor)" }} />
          <div className="absolute inset-0 rounded-lg border opacity-10 -z-[1]" style={{ borderColor: "var(--typeColor)" }} />
          <i className="fa-light fa-fw fa-house-building"></i>
        </div>
        <div className="space-y-1 flex-grow flex-shrink">
          <div className="flex items-start justify-between gap-4">
            <div className="text-sm 2xl:text-base text-md-dark font-semibold">{data?.user?.firstName + " " + data?.user?.lastName || ""}</div>
            <div className="relative flex items-center justify-center text-xs font-semibold pb-0.5 h-6 px-2 rounded" style={{ color: "var(--typeColor)" }}>
              <div className="absolute inset-0 rounded opacity-10" style={{ backgroundColor: "var(--typeColor)" }} />
              <div className="absolute inset-0 rounded border opacity-10" style={{ borderColor: "var(--typeColor)" }} />
              {data?.billingAddress?.label}
            </div>
          </div>
          <div className="text-xs 2xl:text-sm text-slate-500 tracking-wide flex items-start gap-2 2xl:gap-3">
            <i className="fa-regular flex-shrink-0 fa-fw fa-buildings pt-1" style={{ color: "var(--typeColor)" }}></i>
            <span>
              {data?.billingAddress?.address1}
              <br />
              {data?.billingAddress?.address2}
            </span>
          </div>
          <div className="text-xs 2xl:text-sm text-slate-500 tracking-wide flex items-start gap-2 2xl:gap-3">
            <i className="fa-regular flex-shrink-0 fa-fw fa-phone pt-1" style={{ color: "var(--typeColor)" }}></i>
            <span>{data?.billingAddress?.phone}</span>
          </div>
          <div className="text-xs 2xl:text-sm text-slate-500 tracking-wide flex items-start gap-2 2xl:gap-3">
            <i className="fa-regular flex-shrink-0 fa-fw fa-envelope pt-1" style={{ color: "var(--typeColor)" }}></i>
            <span>{data?.user?.email}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetailsAddress;